import LoginPage, { getDefaultPageData } from "components/pages/LoginPage";
import { BCMSStateManagerCRUD } from "bcms-react";

/**
 * @name CaptureFirstLoginUserIDEntered
 * @returns {React.Component}
 * @description Capture component for the login page with the user
 * id entered. For the first time login group
 */
export default function CaptureFirstLoginUserIDEntered(props) {
    // Initalize a new instance of BCMSStateManager with the default page data
    // that updates the user id property
    const data = BCMSStateManagerCRUD.init(getDefaultPageData())
        .update([ "userID" ], "DemoUser")
        .submit();

    // Return the login page component passing the data variable
    return <LoginPage data={ data } />
}